import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/articles";

export default function TrendingSection() {
  return (
    <section className="bg-background-100 py-12 md:py-20" aria-label="热门爆料">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              热门<span className="text-primary-500">爆料</span>
            </h2>
            <p className="text-foreground-500 text-sm mt-1">
              24小时内热度最高的吃瓜现场
            </p>
          </div>
          <span className="px-4 py-1.5 bg-foreground-900 text-white text-xs font-medium rounded-full whitespace-nowrap">
            实时更新
          </span>
        </div>

        {/* Cards */}
        <div className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide">
          {featuredArticles.map((article) => (
            <article
              key={article.id}
              className="snap-start shrink-0 w-72 md:w-80 bg-background-50 rounded-xl overflow-hidden group cursor-pointer"
              itemScope
              itemType="https://schema.org/Article"
            >
              <Link to={`/article/${article.id}`} className="block">
                <div className="w-full h-64 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    itemProp="image"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                      <p className="text-xs text-primary-600 font-medium mb-1" itemProp="articleSection">
                        {article.category}
                      </p>
                      <p className="text-sm text-foreground-700 leading-snug line-clamp-2" itemProp="headline">
                        {article.excerpt}
                      </p>
                    </div>
                    <div className="shrink-0 text-right">
                      <p className="text-2xl font-bold text-foreground-900">
                        {article.heat.toLocaleString()}
                      </p>
                      <p className="text-[10px] text-foreground-400">热度值</p>
                    </div>
                  </div>
                  <meta itemProp="datePublished" content={article.publishDate} />
                  <meta itemProp="author" content={article.author} />
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}